import { createAsyncThunk } from "@reduxjs/toolkit";
import { patch, post } from "helpers/api_helper";
import {
  ADD_CUSTOMER,
  ADD_RECHARGE_TO_CUSTOMER_WALLET,
  GET_ALL_CUSTOMERS,
  GET_BOOKING_HISTORY,
  GET_CUSTOMER_CHART_DETAILS,
  GET_CUSTOMER_DETAILS,
  GET_CUSTOMER_WALLET_TRANSACTIONS,
  GET_CUSTOMERS_LIST,
  GET_PLATFORM_VERSIONS,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_STATUS,
} from "helpers/url_helper";

export const getAllCustomers = createAsyncThunk(
  GET_ALL_CUSTOMERS,
  async (payload) => {
    const response = await post(GET_ALL_CUSTOMERS, payload);
    return response;
  }
);

export const getCustomerDetails = createAsyncThunk(
  GET_CUSTOMER_DETAILS,
  async (payload) => {
    const response = await post(GET_CUSTOMER_DETAILS, payload);
    return response;
  }
);

export const updateCustomerStatus = createAsyncThunk(
  UPDATE_CUSTOMER_STATUS,
  async (payload) => {
    const response = await patch(UPDATE_CUSTOMER_STATUS, payload);
    return response;
  }
);

export const getAllBookingHistory = createAsyncThunk(
  GET_BOOKING_HISTORY,
  async (payload) => {
    const response = await post(GET_BOOKING_HISTORY, payload);
    return response;
  }
);

export const getCustomerWalletTransactions = createAsyncThunk(
  GET_CUSTOMER_WALLET_TRANSACTIONS,
  async (payload) => {
    const response = await post(GET_CUSTOMER_WALLET_TRANSACTIONS, payload);
    return response;
  }
);

export const addRechargeToCustomerWallet = createAsyncThunk(
  ADD_RECHARGE_TO_CUSTOMER_WALLET,
  async (payload) => {
    const response = await post(ADD_RECHARGE_TO_CUSTOMER_WALLET, payload);
    return response;
  }
);

export const getCustomerDropdownList = createAsyncThunk(
  GET_CUSTOMERS_LIST,
  async (payload) => {
    const response = await post(GET_CUSTOMERS_LIST, payload);
    return response;
  }
);

export const getCustomerChartDetails = createAsyncThunk(
  GET_CUSTOMER_CHART_DETAILS,
  async (payload) => {
    const response = await post(GET_CUSTOMER_CHART_DETAILS, payload);
    return response;
  }
);

export const getPlatformVersions = createAsyncThunk(
  GET_PLATFORM_VERSIONS,
  async (payload) => {
    const response = await post(GET_PLATFORM_VERSIONS, payload);
    return response;
  }
);

export const addCustomer = createAsyncThunk(ADD_CUSTOMER, async (payload) => {
  const response = await post(ADD_CUSTOMER, payload);
  return response;
});

export const updateCustomer = createAsyncThunk(
  UPDATE_CUSTOMER,
  async (payload) => {
    const response = await patch(UPDATE_CUSTOMER, payload);
    return response;
  }
);
